import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import {Link} from 'react-router-dom'

const Logo = (props) => {
    
    return (
        <Link to={'/'}>
            <img className='nrt-logo'
                 style={props.style }
                 src={props.imgSrc}
                 alt={props.title}
                 title={props.title}
            />
        </Link>
    )
}

Logo.propTypes = {
    style: PropTypes.object,
    imgSrc: PropTypes.string ,
    title: PropTypes.string
}

Logo.defaultProps = {}

export default Logo



// WEBPACK FOOTER //
// ./src/components/_minha-central/Logo/index.js